export type ForwardingKind =
  | 'all'
  | 'busy'
  | 'no_answer'
  | 'unreachable'
  | 'cancel';

export type ForwardingCodes =
  | { mode: 'sms'; to: string; templates: string[] }
  | { mode: 'dial'; templates: string[] }
  | { mode: 'none' };

export interface OperatorForwarding {
  id: 'lmt' | 'tele2' | 'bite' | 'tet';
  codes: Record<ForwardingKind, ForwardingCodes>;
}

export const FORWARDING_KINDS: ForwardingKind[] = [
  'all',
  'busy',
  'no_answer',
  'unreachable',
  'cancel',
];

export const CALL_FORWARDING_OPERATORS: OperatorForwarding[] = [
  {
    id: 'lmt',
    codes: {
      all: { mode: 'sms', to: '1688', templates: ['PA {number}'] },
      busy: { mode: 'sms', to: '1688', templates: ['PAA {number}'] },
      no_answer: { mode: 'sms', to: '1688', templates: ['PAN {number}'] },
      unreachable: { mode: 'sms', to: '1688', templates: ['PAZ {number}'] },
      cancel: { mode: 'sms', to: '1688', templates: ['PA STOP'] },
    },
  },
  {
    id: 'tele2',
    codes: {
      all: { mode: 'dial', templates: ['**21*{number}#'] },
      busy: { mode: 'dial', templates: ['**67*{number}#'] },
      no_answer: { mode: 'dial', templates: ['**61*{number}#'] },
      unreachable: { mode: 'dial', templates: ['**62*{number}#'] },
      cancel: {
        mode: 'dial',
        templates: ['##21#', '##67#', '##61#', '##62#'],
      },
    },
  },
  {
    id: 'bite',
    codes: {
      all: { mode: 'dial', templates: ['*21*{number}#'] },
      busy: { mode: 'dial', templates: ['*67*{number}#'] },
      no_answer: { mode: 'dial', templates: ['*61*{number}#'] },
      unreachable: { mode: 'dial', templates: ['*62*{number}#'] },
      cancel: {
        mode: 'dial',
        templates: ['##21#', '##67#', '##61#', '##62#'],
      },
    },
  },
  {
    id: 'tet',
    codes: {
      all: { mode: 'dial', templates: ['*21*{number}#'] },
      busy: { mode: 'dial', templates: ['*67*{number}#'] },
      no_answer: { mode: 'dial', templates: ['*61*{number}#'] },
      unreachable: { mode: 'none' },
      cancel: { mode: 'dial', templates: ['#21#', '#67#', '#61#'] },
    },
  },
];

export const fillForwardingTemplate = (
  template: string,
  number: string,
  placeholder: string
) => template.replace(/\{number\}/g, number || placeholder);
